import { Inject, Injectable } from '@angular/core';
import { AuthConfig, OAuthModuleConfig } from 'angular-oauth2-oidc';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { OIDC_SILENT_REFRESH_FRAME_URL } from 'src/app/extensions/constants/commonConstants';
import { uriNormalize } from 'src/app/extensions/utilities';

@Injectable()
export class ConfigService {
  constructor(@Inject(ENV_CONFIG) private _config: env.EnvData) {}

  getAuthConfig(): AuthConfig {
    return {
      issuer: this._config.ISSUER,
      clientId: this._config.CLIENT_ID,
      scope: this._config.SCOPES,
      redirectUri: uriNormalize(this._config.REDIRECT_URI),
      silentRefreshRedirectUri: window.location.origin + OIDC_SILENT_REFRESH_FRAME_URL,
      silentRefreshTimeout: 30000,
      useSilentRefresh: true,
      postLogoutRedirectUri: uriNormalize(this._config.POST_LOGOUT_REDIRECT_URI),
      responseType: 'code',
      sessionCheckIntervall: 15000,
      timeoutFactor: 0.75,
      useIdTokenHintForSilentRefresh: false,
      clearHashAfterLogin: false,
      requestAccessToken: true,
      showDebugInformation: this._config.LOGGING_ENABLED,
      sessionChecksEnabled: this._config.PRODUCTION, //for development environment this needs to be always false because IDM is on a different domain and cross-site cookies are not allowed
      strictDiscoveryDocumentValidation: true,
      requireHttps: this._config?.REQUIRE_HTTPS ?? true, //for local idm use false
    };
  }

  getOAuthModuleConfig(): OAuthModuleConfig {
    return {
      resourceServer: {
        allowedUrls: [
          this._config.PORTAL_BACKEND_APIASYNC_URL ?? '',
          this._config.PORTAL_BACKEND_APISYNC_URL ?? '',
          this._config.PORTAL_TASK_APIASYNC_URL ?? '',
          this._config.PORTAL_TASK_APISYNC_URL ?? '',
          this._config.TENANT_BACKEND_APISYNC_URL ?? '',
          this._config.PORTAL_SIGNALR_API_URL ?? '',
        ],
        sendAccessToken: true,
      },
    };
  }
}
